module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogContentSwitcher":{"title":"Nalezeno v","nav":{"articles":"Článcích","faq_questions":"Poradně","products":"Produktech a&nbsp;kategoriích"}}}}')
  delete Component.options._Ctor
}
